import { useDelPersonMutation, useGetTreeTestQuery } from "store/storeQuery/delApi"
import { DelButton, BackButton, ButtonDiv, DeleteWrapper, TextWrapper, LineDiv } from "./style"
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { getTreeCurrentCardData } from "store/slices/tree/selectors";


interface IDelProps {
    setIsOpenModal: (val: boolean) => void
}

export const DeletePersonModal = ({ setIsOpenModal }: IDelProps) => {
    const [delPersonAsync] = useDelPersonMutation()
    const CardInfo = useSelector(getTreeCurrentCardData);
    const params = useParams()
    const { data: tree } = useGetTreeTestQuery(params.id)
    const navigate = useNavigate()
    const handleClickDelete = () => {
        if (CardInfo.id !== localStorage.getItem('idRoot')) {
            delPersonAsync({ id: CardInfo.id })
        }
        console.log(tree)
        setIsOpenModal(false)

        navigate('/tree')
    }
    return (
        <DeleteWrapper>
            <LineDiv />
            <TextWrapper>
                Хотите удалить карточку родственника из древа?<br />
                Отменить это действие будет невозможно
            </TextWrapper>
            <ButtonDiv>
                <BackButton variant='outlined' color="secondary" onClick={() => { setIsOpenModal(false) }}>Отменить</BackButton>
                <DelButton variant='contained' className='deleteProfile' onClick={handleClickDelete}>Удалить</DelButton>

            </ButtonDiv>
        </DeleteWrapper>
    )
}